export const DRIVER_CATEGORIZATION_OPTIONS = [
    {
        localizationSlug: 'COMPANY_DRIVER',
        value: 'company_driver',
        key: 'COMPANY_DRIVER',
    },
    {
        localizationSlug: 'OWNER_OPERATOR',
        value: 'owner_operator',
        key: 'OWNER_OPERATOR',
    },
    {
        localizationSlug: 'SUBCONTRACTOR',
        value: 'subcontractor',
        key: 'SUBCONTRACTOR',
    },
];
